const PAGES = [
  { name: "/Inicio" },
  { name: "/Pagos" },
  { name: "/Certificados" },
  { name: "/Estado" },
  { name: "/404" },
];

export { PAGES };
